import React from "react";

const SideBarBtn = () => {
  return (
    <h2
      style={{
        cursor: "pointer",
      }}
    >
      ☰
    </h2>
  );
};

export default SideBarBtn;
